import { useState } from "react";
import { useSwipeable } from 'react-swipeable';
import { BiCheck, BiCheckDouble, BiReply } from 'react-icons/bi';

const SwipeableMessage = ({
    msg,
    currentUser,
    handleDeleteForMe,
    handleDeleteForEveryone,
    setReplyToMessage,
    formatTime
}) => {
    const [openDropdown, setOpenDropdown] = useState(null); // ✅ Local dropdown state

    const toggleDropdown = (id) => {
        setOpenDropdown(prev => (prev === id ? null : id));
    };

    const swipeHandlers = useSwipeable({
        onSwipedRight: () => setReplyToMessage(msg),
        preventDefaultTouchmoveEvent: true,
        trackMouse: true
    });

    return (
        <div className="message-wrapper">
            <div
                {...swipeHandlers}
                className={`message ${msg.senderId === currentUser.userId ? 'sent' : 'received'}`}
            >
                {msg.replyMessage && (
                    <div className="replied-message">
                        <strong>{msg.replyMessage.senderName}</strong>: <em>{msg.replyMessage.message}</em>
                    </div>
                )}

                <div className="message-options">
                    <div className="menu-icon" onClick={() => toggleDropdown(msg._id)}> ... </div>

                    {openDropdown === msg._id && (
                        <div className="dropdown9876">
                            <button
                                onClick={() => {
                                    handleDeleteForMe(msg._id);
                                    setOpenDropdown(null);
                                }}
                            >
                                Delete For Me
                            </button>

                            {msg.senderId === currentUser.userId && (
                                <button
                                    onClick={() => {
                                        handleDeleteForEveryone(msg._id);
                                        setOpenDropdown(null);
                                    }}
                                >
                                    Delete For Everyone
                                </button>
                            )}
                        </div>
                    )}
                </div>

                <p>
                    {msg.message === "This message was deleted"
                        ? <i style={{ color: "gray" }}>This message was deleted</i>
                        : msg.message
                    }
                </p>

                <div className="message-meta">
                    <span className="timestamp">{formatTime(msg.timestamp)}</span>
                    {msg.senderId === currentUser.userId && (
                        <span className="tick-icon" style={{ marginLeft: '5px', marginTop: '8px' }}>
                            {msg.status === 'sent' && <BiCheck size={15} color="gray" />}
                            {msg.status === 'delivered' && <BiCheckDouble size={15} color="gray" />}
                            {msg.status === 'seen' && <BiCheckDouble size={15} color="blue" />}
                        </span>
                    )}
                </div>
            </div>

            {msg.message !== "This message was deleted" && (
                <div className={`reply-button-container ${msg.senderId === currentUser.userId ? 'sent-align' : 'received-align'}`}>
                    <button className="reply-btn" onClick={() => setReplyToMessage(msg)}>
                        <BiReply size={18} />
                    </button>
                </div>
            )}
        </div>
    );
};

export default SwipeableMessage;
